import { render, staticRenderFns } from "./PaxModal.vue?vue&type=template&id=645ba374&scoped=true&"
import script from "./PaxModal.vue?vue&type=script&lang=js&"
export * from "./PaxModal.vue?vue&type=script&lang=js&"
import style0 from "./PaxModal.vue?vue&type=style&index=0&id=645ba374&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ba374",
  null
  
)

export default component.exports